export class TypeConvention {

    tco_id: string;
    tco_code: string;
    tco_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.tco_id                     = data['tco_id'] ? data['tco_id'] : null;
        this.tco_code                   = data['tco_code'] ? data['tco_code'] : null;
        this.tco_libelle                = data['tco_libelle'] ? data['tco_libelle'] : null;
    }

}
